import { GridData, CardData } from "./board";

export function generateGridData(nColumns: number, nRows: number): GridData[] {
    const gridData: GridData[] = [];
    for (let col = 0; col < nColumns; col++) {
        const colCardData: CardData[] = [];
        for (let row = 0; row < nRows; row++) {
            colCardData.push({
                points: `${letterByNumber(col)}${row + 1}`
            })
        }
        gridData.push({
            cardRows: colCardData
        });
    }
    return gridData;
}

export const letterByNumber = (nVal: number) => String.fromCharCode(nVal + 65)
